import Tabs, { TabsProps } from './Tabs';

export type { TabsProps };
export default Tabs;
